import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { Avatar } from '@material-ui/core';

// Colors
import red from '@material-ui/core/colors/red';
import pink from '@material-ui/core/colors/pink';
import purple from '@material-ui/core/colors/purple';
import deepPurple from '@material-ui/core/colors/deepPurple';
import indigo from '@material-ui/core/colors/indigo';
import blue from '@material-ui/core/colors/blue';
import lightBlue from '@material-ui/core/colors/lightBlue';
import cyan from '@material-ui/core/colors/cyan';
import teal from '@material-ui/core/colors/teal';
import green from '@material-ui/core/colors/green';
import lightGreen from '@material-ui/core/colors/lightGreen';
import lime from '@material-ui/core/colors/lime';
import yellow from '@material-ui/core/colors/yellow';
import amber from '@material-ui/core/colors/amber';
import orange from '@material-ui/core/colors/orange';
import deepOrange from '@material-ui/core/colors/deepOrange';
import brown from '@material-ui/core/colors/brown';
import grey from '@material-ui/core/colors/grey';
import blueGrey from '@material-ui/core/colors/blueGrey';

const colors = [
  red,
  pink,
  purple,
  deepPurple,
  indigo,
  blue,
  lightBlue,
  cyan,
  teal,
  green,
  lightGreen,
  lime,
  yellow,
  amber,
  orange,
  deepOrange,
  brown,
  grey,
  blueGrey,
];

const getRandomInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

const MyAvatarName = (props) => {
  const {
    name,

    isClipName,
    backgroundColor,
    style,
    colorType,
    variant,
    className,

    'data-testid': dataTestId,
  } = props;
  const theme = useTheme();

  let bgColor;
  let char;
  if (name) {
    char = name.substring(0, 1);
    if (backgroundColor) {
      bgColor = backgroundColor;
    } else {
      const greyIndex = 400;
      bgColor = grey[greyIndex];
      if (char && variant === 'color') {
        let color;
        let shade;
        if (colorType === 'character') {
          // Choose color based on name's first character.
          const charCode = char.charCodeAt();
          color = colors[charCode % colors.length];
          shade = ((charCode + 1) % 9) * 100;
          if (shade === 0) shade = 50;
          bgColor = color[shade];
        } else if (colorType === 'random') {
          // Choose color randomly.
          color = colors[getRandomInt(0, colors.length - 1)];
          shade = getRandomInt(0, 9) * 100;
          bgColor = color[shade];
        }
      }
    }
  }

  const newStyle = {
    backgroundColor: bgColor,
    color: bgColor ? theme.palette.getContrastText(bgColor) : null,
    ...style,
  };

  let content;
  if (name) {
    content = isClipName ? char : name;
  }
  return (
    <Avatar
      className={className}
      style={newStyle}
      data-testid={dataTestId}
    >
      {content}
    </Avatar>
  );
};

MyAvatarName.propTypes = {
  name: PropTypes.string.isRequired,

  isClipName: PropTypes.bool,
  backgroundColor: PropTypes.string,
  style: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
    fontSize: PropTypes.string,
  }),
  colorType: PropTypes.oneOf(['character', 'random']),
  variant: PropTypes.oneOf(['default', 'color']),

  'data-testid': PropTypes.string,
};

MyAvatarName.defaultProps = {
  isClipName: true,
  colorType: 'character',
  variant: 'color',
  style: {},
  backgroundColor: undefined,

  'data-testid': undefined,
};

export default MyAvatarName;
